import { UserContext } from 'contexts/ConfigContext';
import { createContext, useContext, useState, Dispatch, SetStateAction } from 'react';
import { getConfig } from 'utils/helperMethods';

type ProfitPoolOverviewContextValue = {
    selectedSubFilter: any;
    setSelectedSubFilter: Dispatch<SetStateAction<any>>;
    selecedPPOUnit: string;
    setSelecedPPOUnit: Dispatch<SetStateAction<string>>;
    selectPPGrowthUnit: string;
    setSelectPPGrowthUnit: Dispatch<SetStateAction<string>>;
};

const ProfitPoolOverviewContext = createContext<ProfitPoolOverviewContextValue | null>(null);

export const ProfitPoolOverviewContextProvider = ({ children }: { children: React.ReactNode }) => {
    const { appConfig } = useContext(UserContext);
    const profitPoolConfig = getConfig('profitPool', appConfig);

    const { defaultAttributeForData } = profitPoolConfig;

    const [selectedSubFilter, setSelectedSubFilter] = useState<any>(defaultAttributeForData);
    const [selecedPPOUnit, setSelecedPPOUnit] = useState<string>('profit_absolute');
    const [selectPPGrowthUnit, setSelectPPGrowthUnit] = useState<string>('profit_growth_absolute');

    const value: ProfitPoolOverviewContextValue = {
        selectedSubFilter,
        setSelectedSubFilter,
        selecedPPOUnit,
        setSelecedPPOUnit,
        selectPPGrowthUnit,
        setSelectPPGrowthUnit,
    };

    return <ProfitPoolOverviewContext.Provider value={value}>{children}</ProfitPoolOverviewContext.Provider>;
};

export const useProfitPoolOverviewContext = () => {
    const context = useContext(ProfitPoolOverviewContext);
    if (!context) {
        throw new Error('useProfitPoolOverviewContext must be used within a ProfitPoolOverviewContextProvider');
    }
    return context;
};
